import React from 'react';

// IP/visitor tracking removed for simplicity & cost reduction.
export const IPTrackingWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>;
